import React, { useState } from 'react';

const ScheduleToggle = ({ scheduleType, onScheduleChange, scheduledTime, onTimeChange }) => {
  const [showPicker, setShowPicker] = useState(false);

  const now = new Date();
  const minDateTime = now?.toISOString()?.slice(0, 16);

  const handleScheduleChange = (type) => {
    onScheduleChange(type);
    if (type === 'later') {
      setShowPicker(true);
    } else {
      setShowPicker(false);
    }
  };

  const formatScheduledTime = (dateTimeStr) => {
    if (!dateTimeStr) return '';
    const date = new Date(dateTimeStr);
    return date?.toLocaleString('en-KE', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-[#0a1628]/60 uppercase tracking-wider">When?</h3>
      <div className="flex bg-[#0a1628]/8 rounded-xl p-1 gap-1">
        <button
          onClick={() => handleScheduleChange('now')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
            scheduleType === 'now' ?'bg-white text-[#0a1628] shadow-sm' :'text-[#0a1628]/50 hover:text-[#0a1628]'
          }`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          Book Now
        </button>
        <button
          onClick={() => handleScheduleChange('later')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
            scheduleType === 'later' ?'bg-white text-[#0a1628] shadow-sm' :'text-[#0a1628]/50 hover:text-[#0a1628]'
          }`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          Schedule Later
        </button>
      </div>
      {scheduleType === 'later' && (
        <div className="bg-white rounded-xl border border-[#0a1628]/10 p-3.5 space-y-2">
          <label className="block text-xs font-medium text-[#0a1628]/60">Select date & time</label>
          <input
            type="datetime-local"
            min={minDateTime}
            value={scheduledTime}
            onChange={(e) => onTimeChange(e?.target?.value)}
            className="w-full text-sm font-medium text-[#0a1628] bg-[#0a1628]/4 border border-[#0a1628]/10 rounded-lg px-3 py-2.5 focus:outline-none focus:border-[#ffd700] focus:ring-1 focus:ring-[#ffd700]/30 transition-colors"
          />
          {scheduledTime && (
            <div className="flex items-center gap-2 p-2 bg-[#ffd700]/10 rounded-lg">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-[#0a1628]">
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span className="text-xs font-medium text-[#0a1628]">
                Scheduled for {formatScheduledTime(scheduledTime)}
              </span>
            </div>
          )}
        </div>
      )}
      {scheduleType === 'now' && (
        <div className="flex items-center gap-2 px-3 py-2 bg-green-50 rounded-xl">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
          <span className="text-xs font-medium text-green-700">Drivers available now · Avg. 3 min pickup</span>
        </div>
      )}
    </div>
  );
};

export default ScheduleToggle;
